export default function stringifyAuthorNames(authors) {
  if (!Array.isArray(authors)) return String(authors);
  return authors.map((obj) => obj.name).join(', ');
}
